import { defineMessages } from 'react-intl';

type MessageKeys = 'voiceDictationButtonLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		voiceDictationButtonLabel: {
			id: 'rovo-chat.voice-dictation.label',
			defaultMessage: 'Dictation',
			description: 'Label for the voice dictation button in the chat input',
		},
	});

export default message;
